import { CSSProperties } from "react";
import { Select, SelectItem } from "@clarkinc/zest-design-system/ui";
import { PaymentMethodDetails } from "../../../models";
import SavedCard from "./SavedCard";

interface Props {
  isDisabled: boolean;
  tokenId?: number;
  savedCards: Readonly<PaymentMethodDetails[]>;
  updateSelectedCard: (newCard: PaymentMethodDetails) => void;
  styles: CSSProperties;
}

const SavedCardDropdown = ({
  isDisabled,
  tokenId,
  savedCards,
  updateSelectedCard,
  styles,
}: Props) => {
  const selectedCard =
    savedCards.find((card) => card.id === tokenId) || savedCards[0]!;

  const handleValueChange = (value: string) => {
    const newSelectedCard =
      savedCards.find((card) => card.id === Number(value)) || selectedCard;
    updateSelectedCard(newSelectedCard);
  };

  const selectedValue = selectedCard?.id.toString();

  return (
    <div className="relative" style={styles}>
      <Select
        theme="wss"
        label="Payment Method"
        hideLabel
        inputSize="large"
        placeholder="Select an option"
        disabled={isDisabled}
        value={selectedValue}
        onValueChange={handleValueChange}
        data-testid="plus-modal-saved-card-dropdown"
      >
        {savedCards.map((card) => (
          <SelectItem value={card.id.toString()} key={card.id}>
            <div className="leading-4">
              <SavedCard savedCard={card} />
            </div>
          </SelectItem>
        ))}
      </Select>
    </div>
  );
};

export default SavedCardDropdown;
